<script lang="ts">
  import Circle from "./Circle.svelte"

  export let backgroundColor: string
  export let size: number

</script>

<Circle
  backgroundColor={backgroundColor}
  borderColor="rgba(0,0,0,.15)"
  size={size}
  class={$$props.class}
/>
